import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router/composables'

import LTextPrompt from '@/global-components/LTextPrompt.vue'
import { useValidatePinCode, tripQueryKeys } from '@/composables/trip'
import { tripModule, authModule, eventModule } from '@/store'
import { useOnboardingStore } from '@/stores/onboarding'
import { TextFieldRules } from '@/utils/enums'
import { logEvent } from '@/utils/utility-manager'
import { useQueryClient } from '@/composables/vue-query'


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinTripModal',
  setup(__props, { expose }) {

expose({ toggleDialog })

const onboardingStore = useOnboardingStore()
const queryClient = useQueryClient()
const router = useRouter()
const { validatePinCode } = useValidatePinCode()

const pinCode = ref<string>('')

async function joinTrip(code: string) {
  pinCode.value = code

  const isValid = await validatePinCode(pinCode.value)
  if (!isValid) {
    logEvent('pin_code_entered', {
      context: authModule.loggedIn ? 'signed_in' : 'onboarding_v3',
      join_method: 'pin_code',
      valid: false,
    })

    eventModule.newError('error.trip.validatePinCode')
    return
  }

  logEvent('pin_code_entered', {
    context: authModule.loggedIn ? 'signed_in' : 'onboarding_v3',
    join_method: 'pin_code',
    valid: true,
  })

  if (!authModule.loggedIn) {
    await redirectToAuthenticate(pinCode.value)
    return
  }

  await tripModule.join(pinCode.value)

  logEvent('trip_joined', {
    context: authModule.loggedIn ? 'signed_in' : 'onboarding_v3',
    join_method: 'pin_code',
  })

  await queryClient.invalidateQueries({ queryKey: tripQueryKeys.lists() })
}

const joinTripPrompt = ref<InstanceType<typeof LTextPrompt> | null>(null)

function toggleDialog(): void {
  if (joinTripPrompt.value) {
    joinTripPrompt.value.toggleDialog()
  }
}

async function redirectToAuthenticate(pinCode: string) {
  if (pinCode) {
    await router.push({
      path: onboardingStore.previousAuthenticatingRoutePath ?? '/sign-up',
      query: { pinCode },
    })
    toggleDialog()
  }
}

return { __sfc: true,onboardingStore, queryClient, router, validatePinCode, pinCode, joinTrip, joinTripPrompt, toggleDialog, redirectToAuthenticate, LTextPrompt, TextFieldRules }
}

})